var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"tag",class:_vm.classes,attrs:{"disabled":_vm.internalDisabled},on:{"click":_vm.hitApi}},[(_vm.iconClass)?_c('i',{class:_vm.iconClass}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d29c3ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Utility/Buttons/ApiPostButton.vue
// module id = 689
// module chunks = 0 1